<template>
  <div>
    <!-- Botón de menú para dispositivos móviles -->
    <button class="menu-toggle" @click="toggleSidebar">
      <ion-icon name="menu-outline"></ion-icon>
    </button>

    <!-- Sidebar -->
    <nav :class="['sidebar', { 'sidebar-hidden': !isSidebarVisible }]">
      <div class="logo-container">
        <img v-if="logoSrc" :src="logoSrc" alt="" />
        <span>{{ nombreEmpresa }}</span>
      </div>
      <ul>
        <li>
          <router-link to="/dashboard" @click="handleMenuClick"
            ><ion-icon name="grid-outline"></ion-icon> Dashboard</router-link
          >
        </li>
        <li>
          <router-link to="/existencias" @click="handleMenuClick"
            ><ion-icon name="cube-outline"></ion-icon> Existencias</router-link
          >
        </li>
        <li>
          <router-link to="/estado-financiero" @click="handleMenuClick"
            ><ion-icon name="stats-chart-outline"></ion-icon> Estado
            Financiero</router-link
          >
        </li>
        <li>
          <router-link to="/cuentas" @click="handleMenuClick"
            ><ion-icon name="wallet-outline"></ion-icon> Cuentas
          </router-link>
        </li>
        <li>
          <router-link to="/movimientos-financieros" @click="handleMenuClick">
            <ion-icon name="swap-horizontal-outline"></ion-icon> Movimientos
            Financieros
          </router-link>
        </li>
        <li>
          <router-link to="/prestamos" @click="handleMenuClick">
            <ion-icon name="cash-outline"></ion-icon> Prestamos
          </router-link>
        </li>
        <li>
          <router-link to="/ventas" @click="handleMenuClick"
            ><ion-icon name="cart-outline"></ion-icon> Ventas</router-link
          >
        </li>
        <!-- ... otros links del menú ... -->
      </ul>

      <!-- <div class="user-profile">
      </div> -->

      <div class="user-profile">
        <button @click="authStore.cambiarEmpresa()">
          <ion-icon name="swap-vertical-outline"></ion-icon> Cambiar Empresa
        </button>
        <button @click="authStore.logout()">
          <ion-icon name="log-out-outline"></ion-icon> Cerrar Sesión
        </button>
      </div>
    </nav>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
const nombreEmpresa = ref(authStore.selectedCompany.Descripcion || "CARCU");

const logoSrc = ref(
  "data:image/gif;base64," + authStore.selectedCompany.LogoData
);

// const logoSrc = "/logo_CARCU.png";

// Estado para controlar la visibilidad del sidebar
const isSidebarVisible = ref(true);

const toggleSidebar = () => {
  isSidebarVisible.value = !isSidebarVisible.value;
};
const handleMenuClick = () => {
  if (window.innerWidth <= 768) {
    isSidebarVisible.value = false; // Ocultar el sidebar en móviles al hacer clic en un enlace
  }
};

// Verificar si se está iniciando desde un móvil
onMounted(() => {
  isSidebarVisible.value = window.innerWidth > 768; // Cambiar el valor según el tamaño de pantalla
});
</script>

<style scoped>
/* Estilos modernos para el sidebar */
.sidebar {
  width: 250px;
  background-color: #34495e;
  color: white;
  display: flex;
  flex-direction: column;
  height: 100vh;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 2000;
}

.sidebar-hidden {
  transform: translateX(-100%);
}

.logo-container {
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: #34495e;
  /* margin-left: 60px; Espacio para evitar que el logo se encime con el botón */
}

.logo-container img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.logo-container span {
  font-size: 1.2rem;
  font-weight: bold;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li {
  padding: 15px;
  transition: background-color 0.3s;
}

ul li:hover {
  background-color: #3a5f7d;
}

ul li a {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
}

ul li a ion-icon {
  margin-right: 10px;
}

.user-profile {
  margin-top: auto;
  padding: 1rem;
  background-color: #34495e;
  display: flex;
  flex-direction: column; /* Asegura que los botones estén en columna */
  align-items: center; /* Centra los botones */
}

.user-profile button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 10px; /* Reduce el margen entre botones */
  font-size: 0.9rem; /* Ajusta el tamaño del texto para pantallas pequeñas */
}

.user-profile button ion-icon {
  margin-right: 10px;
}

.user-profile button:hover {
  color: #ecf0f1;
}

/* Botón de menú para dispositivos móviles */
.menu-toggle {
  display: none;
  position: fixed;
  top: 15px; /* Ajusta la distancia desde la parte superior */
  left: 15px; /* Ajusta la distancia desde la parte izquierda */
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 2001;
}

/* Media query para dispositivos móviles */
@media (max-width: 768px) {
  .logo-container {
    display: flex;
    align-items: center;
    padding: 1rem;
    background-color: #34495e;
    margin-left: 60px; /* Espacio para evitar que el logo se encime con el botón */
  }

  .menu-toggle {
    display: block;
    color: white;
    background-color: #2c3e50;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    transform: translateX(-100%);
  }

  .sidebar-hidden {
    transform: translateX(-100%);
  }

  .sidebar:not(.sidebar-hidden) {
    transform: translateX(0);
  }

  .logo-container {
    margin-left: 60px; /* Ajusta el espacio para el botón de menú */
  }

  .user-profile {
    flex-direction: column; /* Asegura que los botones estén en columna */
    padding: 0.5rem; /* Reduce el padding en móviles */
  }

  .user-profile button {
    font-size: 0.8rem; /* Ajusta el tamaño del texto */
    margin-top: 5px; /* Reduce el espacio entre botones */
  }
}
</style>
